import {
  getDownloadFileQueryKey,
  getDownloadImmagineNodoQueryKey,
  NodoDto,
  useUploadFile,
} from "@/api";
import Card from "@mui/material/Card";
import { Fragment, useMemo } from "react";
import { toast } from "react-toastify";
import Image from "../Images/Image";
import ImageAdd from "../Images/ImageAdd";
import { useTranslation } from "react-i18next";

export type ImmagineEsistenteRef = { id: number };
export type JustUploadedRef = { justUploaded: true; fileId: number };

export default function NodoImmaginiCard({
  nodo,
  immagini,
  onChange,
  editable = false,
}: {
  nodo?: NodoDto;
  immagini: (ImmagineEsistenteRef | JustUploadedRef)[];
  onChange?: (value: (ImmagineEsistenteRef | JustUploadedRef)[]) => void;
  editable?: boolean;
}) {
  const { t } = useTranslation();

  const { mutateAsync: uploadFileAsync } = useUploadFile();

  const immaginiVuote = useMemo(() => {
    const arr = [];
    if (immagini) {
      for (let i = 0; i < 2 - immagini.length; i++) {
        arr.push(i);
      }
    }
    return arr;
  }, [immagini]);

  const handleImageUpload = async (event: any) => {
    const file = event.target.files[0];
    if (file) {
      try {
        let result = await uploadFileAsync({
          data: { file },
        });
        onChange?.([
          ...immagini,
          { justUploaded: true, fileId: result.data.id },
        ]);
      } catch (error: any) {
        handleUploadError(error.status);
      }
    }
  };

  function handleUploadError(status?: number | undefined) {
    const msg =
      status === 413
        ? t("nodoImmaginiCard.errori.fileTroppoGrande")
        : t("nodoImmaginiCard.errori.caricamento");
    toast.error(msg);
  }

  if (editable) {
    return (
      <Card
        sx={{
          minWidth: {
            xs: "100%",
          },
          display: "flex",
          flexDirection: "row",
          padding: 2,
          gap: 2,
        }}
      >
        {immagini?.map((immagine, i) => {
          const justUploaded = "justUploaded" in immagine;

          const url = justUploaded
            ? getDownloadFileQueryKey(immagine.fileId!)[0]
            : nodo
            ? getDownloadImmagineNodoQueryKey(nodo.id, immagine.id)[0]
            : null;

          if (!url) {
            return <Fragment key={i} />;
          }

          return (
            <Image
              key={i}
              src={url}
              alt={t("nodoImmaginiCard.alt", { index: i + 1 })}
              handleImageDelete={() => {
                const newImmagini = [...immagini];
                newImmagini.splice(i, 1);
                onChange?.(newImmagini);
              }}
            />
          );
        })}
        {immaginiVuote.map((_, i) => (
          <ImageAdd key={i} handleImageUpload={handleImageUpload} />
        ))}
      </Card>
    );
  } else if (nodo && immagini.length > 0) {
    return (
      <Card
        sx={{
          minWidth: {
            xs: "100%",
          },
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          padding: 2,
          gap: 2,
        }}
      >
        {nodo.immagini?.map((immagine, i) => (
          <Image
            key={immagine.id}
            src={getDownloadImmagineNodoQueryKey(nodo.id, immagine.id!)[0]}
            alt={t("nodoImmaginiCard.alt", { index: i + 1 })}
            canDelete={false}
          />
        ))}
      </Card>
    );
  } else {
    return null;
  }
}
